import {
  takeLatest, put, call, all,
} from 'redux-saga/effects';
import BrandingFileService from '@services/branding-file';
import DashboardBrandingService from '@services/dashboard-branding';
import FhqBrandingService from '@services/fhq-branding';
import * as actions from '@actions';
import {
  BrandingFile,
  BrandingFileDto,
  DashboardBranding,
  DashboardBrandingDto,
  FhqBranding,
  FhqBrandingDto,
} from '@rootCommon/types/branding';
import { IdType } from '@rootCommon/types/common';

import { AxiosError } from 'axios';
import { SagaGenerator } from './index';

// Branding Files

// fetch
function* fetchBrandingFilesAsync() {
  try {
    const brandingFiles: BrandingFile[] = yield call(BrandingFileService.getList);

    yield put(actions.fetchBrandingFiles.success(brandingFiles));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchBrandingFiles.failure(error));
  }
}

function* watchFetchBrandingFiles() {
  yield takeLatest(actions.fetchBrandingFiles.request, fetchBrandingFilesAsync);
}

// create
function* createBrandingFilesAsync(action: { payload: BrandingFileDto }) {
  try {
    const brandingFile: BrandingFile = yield call(BrandingFileService.create, action.payload);

    yield put(actions.createBrandingFile.success(brandingFile));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.createBrandingFile.failure(error));
  }
}

function* watchCreateBrandingFile() {
  yield takeLatest(actions.createBrandingFile.request, createBrandingFilesAsync);
}

// delete
function* deleteBrandingFilesAsync(action: { payload: IdType }) {
  try {
    yield call(BrandingFileService.delete, action.payload);
    yield put(actions.deleteBrandingFile.success(action.payload));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.deleteBrandingFile.failure(error));
  }
}

function* watchDeleteBrandingFile() {
  yield takeLatest(actions.deleteBrandingFile.request, deleteBrandingFilesAsync);
}

// Dashboard Branding

// fetch
function* fetchDashboardBrandingAsync() {
  try {
    const dashboardBranding: DashboardBranding = yield call(DashboardBrandingService.get);

    yield put(actions.fetchDashboardBranding.success(dashboardBranding));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchDashboardBranding.failure(error));
  }
}

function* watchFetchDashboardBranding() {
  yield takeLatest(actions.fetchDashboardBranding.request, fetchDashboardBrandingAsync);
}

// update
function* updateDashboardBrandingAsync(action: { payload: { id: IdType; data: DashboardBrandingDto } }) {
  try {
    const dashboardBranding: DashboardBranding = yield call(
      DashboardBrandingService.update,
      action.payload.id,
      action.payload.data,
    );

    yield put(actions.updateDashboardBranding.success(dashboardBranding));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateDashboardBranding.failure(error));
  }
}

function* watchUpdateDashboardBranding() {
  yield takeLatest(actions.updateDashboardBranding.request, updateDashboardBrandingAsync);
}

// Fhq Branding

// fetch
function* fetchFhqBrandingAsync(action: { payload: IdType }) {
  try {
    const fhqBranding: FhqBranding = yield call(FhqBrandingService.getListBySiteId, action.payload);

    yield put(actions.fetchFhqBranding.success(fhqBranding));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.fetchFhqBranding.failure(error));
  }
}

function* watchFetchFhqBranding() {
  yield takeLatest(actions.fetchFhqBranding.request, fetchFhqBrandingAsync);
}

// update
function* updateFhqBrandingAsync(action: { payload: { id: IdType; data: FhqBrandingDto } }) {
  try {
    const fhqBranding: FhqBranding = yield call(FhqBrandingService.update, action.payload.id, action.payload.data);

    yield put(actions.updateFhqBranding.success(fhqBranding));
  } catch (e) {
    const error = e as AxiosError | Error;
    yield put(actions.updateFhqBranding.failure(error));
  }
}

function* watchUpdateFhqBranding() {
  yield takeLatest(actions.updateFhqBranding.request, updateFhqBrandingAsync);
}

// all
function* watchBranding(): SagaGenerator {
  yield all([
    watchFetchBrandingFiles(),
    watchCreateBrandingFile(),
    watchDeleteBrandingFile(),
    watchFetchDashboardBranding(),
    watchUpdateDashboardBranding(),
    watchFetchFhqBranding(),
    watchUpdateFhqBranding(),
  ]);
}

export default watchBranding;
